import { Box } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import "react-lazy-load-image-component/src/effects/blur.css";

export default function LazyImage({ src, alt = "" }) {
  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      height="100%"
      width="100%"
      placeholder={<Box bgcolor="black" height="100%" width="100%" />}
      // placeholder={
      //   <LazyLoadImage
      //     src={placeholderSrc}
      //     style={{ objectFit: "cover" }}
      //     alt={alt}
      //     height="100%"
      //     width="100%"
      //   />
      // }
      style={{ objectFit: "cover" }}
    />
  );
}
